<template>
  <fader>
    <div
      :style="isExpired"
      class="c-effect text-var-sm leading-none relative whitespace-no-wrap"
    >
      <div
        class="u-columns-1fr-min-min grid gap-2 items-center w-full bg-tint-less tint:focus-within:hover bevel rounded-sm"
      >
        <span class="relative">
          <display-field
            :focus="shouldFocusName"
            :value="data.name"
            @input="name => updateProps({ name, affected })"
            class="has-text-input leading-tighter w-full"
            :inputClasses="[
              ` text-readable py-2 px-side `,
              { ' line-through ': data.duration < 1 },
            ]"
            placeholder="Effect details"
          />
        </span>
        <span class="relative">
          <base-field
            :focus="shouldFocusDuration"
            :value="data.duration"
            @input="updateDuration"
            class="text-readable block ml-auto text-center"
            placeholder="0"
            size="4"
            style="width: 1.6em"
            type="number"
          />
        </span>
        <button
          @click="e => destroy({ affected, id: data.id })"
          title="Remove effect"
          class="button-reset o-button"
        >
          ×
        </button>
      </div>
    </div>
  </fader>
</template>

<script>
import BaseField from './BaseField'
import DisplayField from './DisplayField'
import { mapActions } from 'vuex'
import { updateProps } from '@/utilities/helpers'

export default {
  components: {
    BaseField,
    DisplayField,
  },

  props: {
    affected: {
      type: String,
      required: true,
    },
    data: {
      type: Object,
      default: () => ({
        name: ``,
        duration: 1,
      }),
      validator: function({ name, duration }) {
        return (
          typeof name === `string` &&
          (Number.isInteger(duration) || typeof duration === `string`)
        )
      },
    },
  },

  created() {
    this.unsubToRoundActions = this.$store.subscribeAction(action => {
      const subbedActions = [
        `battle/rounds/increment`,
        `battle/rounds/decrement`,
      ]
      if (!subbedActions.includes(action.type)) return

      const modifier = action.type === subbedActions[0] ? -1 : 1
      this.updateProps({
        duration: this.data.duration * 1 + modifier,
        affected: this.affected,
      })
    })
  },

  beforeDestroy() {
    this.unsubToRoundActions()
  },

  computed: {
    id() {
      return this.data.id
    },

    isExpired() {
      return this.data.duration < 1
        ? { opacity: 0.3, background: `rgba(200, 200, 200, 0.2)` }
        : {}
    },

    shouldFocusName() {
      return this.data.name === ``
    },

    shouldFocusDuration() {
      return !this.shouldFocusName && this.data.duration === 1
    },
  },

  methods: {
    ...mapActions(`effect`, [`destroy`, `update`]),

    updateDuration(duration) {
      this.updateProps({ duration: duration * 1, affected: this.affected })
    },

    updateProps,
  },
}
</script>

<style lang="postcss" scoped>
.has-text-input input {
  width: calc(100% + 1rem);
}

.u-columns-1fr-min-min {
  grid-template-columns: 1fr min-content min-content;
}
</style>
